const fr = {
    Dashboard : 'Tableau de bord',
    Post : 'Publier',
    Posts : 'Des postes',
    New_Post: 'New Post',
    Article : 'Article',
    Articles : 'Articles',
    New_Article: 'New Article',
    Category : 'Category',
    Categories : 'Categories',
    New_Category: 'New Category',
    Customer : 'Customer',
    Customers : 'Customers',
    New_Customer: 'New Customer',
    List : 'List',
    Lists : 'Lists',
    New_List: 'New List',
    Page : 'Page',
    Pages : 'Pages',
    New_Page: 'New Page',
    Profile : 'Profile',
    New_Profile: 'New Profile',
    Setting : 'Setting',
    New_Setting: 'New Setting',
    User : 'User',
    Users : 'Users',
    New_User: 'New User',
    Choose_Image: 'Choose Image',
    View: 'View',
    Save: 'Save',
    Cancel: 'Cancel',
    Delete: 'Delete',
    Edit: 'Edit',
    Add: 'Add',
    Description: 'Description',
    Filters: 'Filters',
    Hide_Filters: 'Hide Filters',
    Show_Filters: 'Show Filters',
    Clear_all_filters: 'Clear all filters',
    Confirm_Message: 'Are you sure to delete this',
    No_Data: 'No Data to Show',
    Done: 'Done',
    Details: 'Details',
    Close: 'Close',
    Social_Media: 'Social Media',
    Followers: 'Followers',
    Additional_Information: 'Additional Information',
    Status: 'Status',
    Note: 'Note',
    POST_CREATED: 'POST CREATED',
    CUSTOMERS: 'CUSTOMERS',
    WARNINGS: 'WARNINGS',
    Activities: 'Activities',
    CONTENTS_CREATED: 'CONTENTS CREATED',
    CONTENTS_SHARED: 'CONTENTS SHARED',
    ACTIVE_CUSTOMERS: 'ACTIVE CUSTOMERS',
    Recent_Content: 'Recent Content',
    Timeline: 'Timeline',
    Settings: 'Settings',
    Home: 'Home',
    Logout: 'Logout',
    Logout_warning: 'While logged out you are unable to manage your profile and conduct other activities that require you to be logged in.',
    My_Profile: 'My Profile',
    Crop_Image: 'Crop Image',
    Original_Image: 'Original Image',
    Preview_Image: 'Preview Image',
    Signed_in_as: 'Signed in as',
    User_Not_Exist: 'The user does not exist. Please login with registered user credentials.',
    Field_Required: 'This field is required',
    Login_to_your_Account: 'Login to your Account',
    Login_Help_Text: 'Please type your email and password to log in',
    Email: 'Email',
    Password: 'Password',
    Forgotten_your_password: 'Forgotten your password?',
    Reset_Password: 'Reset _Password.',
    Log_in: 'Log in',
    No_Account: "Don't have an Account?",
    Register_account: 'Register account.',
    Password_Criteria: 'Must Contain 6 Characters',
    Password_Match: 'Passwords must match',
    Create_New_Account: 'Create New Account',
    Create_Request: 'Please fill registration to create account',
    First_Name: 'First Name',
    Last_Name: 'Last Name',
    Create_Password: 'Create Password',
    Confirm_Password: 'Confirm Password',
    Terms_Agree_Text: "By clicking on 'Create Account button' I agree to the",
    Terms_of_Service: 'Terms of Service',
    Privacy_Policy: 'Privacy Policy',
    Create_Account: 'Create Account',
    Have_Account: 'Do you have an Account?',
    Log_In: 'Log In',
    Reset_Password_Inst: 'Please type your email and we will send instructions',
    Reset_Password_Thanks: 'Thanks! Email with password reset instruction has been sent to ',
    Login: 'Login',
    Reset: 'Reset',
    My_Profile: 'My Profile',
    Password_changed_successfully: 'Password changed successfully',
    Old_Password: 'Old Password',
    New_Password: 'New Password',
    Channel_change_warning: 'On Channel change Unsaved Data will be lost.',
    OK: 'OK',
    Save_Data: 'Save_Data',
    Platforms: 'Platforms',
    Publish: 'Publish',
    Publish_Confirm: 'You are about to publish content. Are you sure?',
    Publish_Now: 'Publish Now',
    Publish_Later: 'Publish Later',
    Un_Publish: 'Un-Publish',
    Delete_Confirm: "Are you sure to delete the post? This action can't be reverted back.",
    Draft: 'Draft',
    Compose: 'Compose',
    Add_Images: 'Add Images',
    Add_Videos: 'Add Videos',
    Sub_Category: 'Sub-Category',
    Twitter: 'Twitter',
    Like: 'Like',
    Comment: 'Comment',
    Share: 'Share',
    Facebook: 'Facebook',
    See_more: 'See more',
    comments: 'comments',
    Preview: 'Preview',
    Tab_View: 'Tab View',
    Calendar_View: 'Calendar View',
    Error_Loading_Timeline: 'Error Loading Timeline',
    No_Posts: 'No Posts',
    Published: 'Published',
    Scheduled: 'Scheduled',
    Show_Less: 'Show Less',
    More: 'More',
    Product: 'Product',
    Products: 'Products',
    New_Product: 'New Product',
    Order: 'Order',
    Orders: 'Orders',
    Offer: 'Offer',
    Offers: 'Offers',
    New_Offer: 'New Offer',
}

export default fr